import { j as jsxRuntimeExports } from './../../../../ext/react/jsx-runtime.js';
import clsx from 'clsx';
import * as React from 'react';
import styles from './LazyImage.module.css.js';

function LazyImage({ rootMargin = '50px', threshold, src, srcSet, className, ...restProps }) {
    const observer = React.useRef();
    const listenerCallbacks = React.useRef(new Map());
    const imageRef = React.useRef(null);
    const [isInView, setIsInView] = React.useState(false);
    const [isLoaded, setIsLoaded] = React.useState(false);
    function handleIntersections(entries) {
        entries.forEach((entry) => {
            var _a;
            const image = entry.target;
            if (listenerCallbacks.current && listenerCallbacks.current.has(image)) {
                const callback = listenerCallbacks.current.get(image);
                if (callback && (entry.isIntersecting || entry.intersectionRatio > 0)) {
                    (_a = observer.current) === null || _a === void 0 ? void 0 : _a.unobserve(entry.target);
                    listenerCallbacks.current.delete(image);
                    callback();
                }
            }
        });
    }
    function getIntersectionObserver() {
        if (observer.current === undefined) {
            observer.current = new IntersectionObserver(handleIntersections, {
                rootMargin,
                threshold,
            });
        }
        return observer;
    }
    function useIntersection(element, callback) {
        React.useEffect(() => {
            var _a;
            const target = element.current;
            if (target) {
                const observer = getIntersectionObserver();
                listenerCallbacks.current.set(target, callback);
                (_a = observer.current) === null || _a === void 0 ? void 0 : _a.observe(target);
            }
            return () => {
                var _a;
                if (target) {
                    listenerCallbacks.current.delete(target);
                    (_a = observer.current) === null || _a === void 0 ? void 0 : _a.unobserve(target);
                }
            };
        }, []);
    }
    function handleImageLoad() {
        setIsLoaded(true);
    }
    useIntersection(imageRef, () => {
        setIsInView(true);
    });
    React.useEffect(() => {
        const img = imageRef.current;
        if (img) {
            img.addEventListener('load', handleImageLoad);
        }
        return () => {
            if (img) {
                img.removeEventListener('load', handleImageLoad);
            }
        };
    }, []);
    return (jsxRuntimeExports.jsx("img", { ref: imageRef, src: isInView ? src : undefined, srcSet: isInView ? srcSet : undefined, className: clsx(className, styles.image, {
            [styles.loaded]: isLoaded,
        }), ...restProps }));
}

export { LazyImage };
//# sourceMappingURL=LazyImage.js.map
